const tagsView = {
  refresh: "รีเฟรช",
  close: "ปิด",
  closeOthers: "ปิดอื่น ๆ",
  closeAll: "ปิดทั้งหมด"
} 
export default tagsView